var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"search-results-title"},[_vm._v("\n    "+_vm._s(_vm.$t('search.search_results', { keywords: _vm.query }))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }